import { render, staticRenderFns } from "./news.vue?vue&type=template&id=7957fdc6&scoped=true&"
import script from "./news.vue?vue&type=script&lang=js&"
export * from "./news.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7957fdc6",
  null
  
)

export default component.exports